import { useLazyQuery } from '@apollo/client/react';
import { CHECK_PARAMETERS_QUERY } from './useCheckParameters.gql';
export const useCheckParameters = () => {
  return useLazyQuery(CHECK_PARAMETERS_QUERY);
};
